<template>
  <div class="loading">
      <img src="@/assets/img/loading.gif" alt="">
  </div>
</template>

<script>
export default {
};
</script>

<style scoped>
  .loading {
    position: relative;
    width: 100%;
    height: 100%;
    background-color: black;
    z-index: 1000;
  }
  .loading img{
    position: fixed;
    left: 50%;
    top: 50%;
    width: 150px;
    height: 150px;
    /* transform: translateX(-50%);
    transform: translateY(-50%); */
    
    transform: translate(-50%, -50%);
  }
</style>
